<template>
  <div class="c-certificate">
    <img id="img" src="" alt="" :width="width" :height="height">
  </div>
</template>

<script>
import { Certificate } from '@/libs/canvas'

export default {
  props: {
    name: {
      type: String,
      default: '张三丰'
    },
    content: {
      type: String,
      default: '先生/女士 于2018年10月27日-28日，顺利完成《人工智能基础与实践》专题培训的学习，考核通过并取得优异成绩，特发此证。'
    },
    time: {
      type: String,
      default: '发证日期：2018年10月29日'
    },
    code: {
      type: String,
      default: '证书编号：3084590'
    },
    width: {
      type: [Number, String],
      default: 300
    },
    height: {
      type: [Number, String],
      default: 'auto'
    }
  },
  mounted () {
    const canvas = document.createElement('canvas')
    canvas.width = 850
    canvas.height = 600
    new Certificate({
      el: canvas
    }).createCertificate({
      name: this.name,
      content: this.content,
      time: this.time,
      code: this.code
    })
    
    let src = canvas.toDataURL('image/png')
    document.querySelector('#img').src = src
  }
}
</script>
